<template>
    <modal v-model="showModal" @hidden="onHide" size="large">
        <template slot="header">
            <div v-if="isLoggedIn">
                <h2 class="display-4 montserrat-bold mt-4 mb-0">Add Booking Address</h2>
                <div class="mt--2 heading-small">Add an address to search your preferred shops</div>
            </div>
            <div v-else>
                <h2 class="display-4 montserrat-bold mt-4 mb-0">Search Booking Address</h2>
                <div class="mt--2 heading-small">Search your preferred address to place your booking</div>
            </div>
        </template>
        <form @submit.prevent="save" class="row">
            <div class="col-lg-6 col-sm-12 mb-4">
                <google-map @change="syncMapData" :initial-location="initialMapPosition" ></google-map>
            </div>
            <div class="col-lg-6 col-sm-12">
                <div class="row">
                    <div class="col-lg-11">
                        <form-input
                            v-if="isLoggedIn"
                            placeholder="Address name"
                            label="Address name"
                            v-model="form.name"
                            ref="name"
                        ></form-input>
                    </div>
                    <div class="col-lg-11">
                        <form-input
                            placeholder="Unit/House no, Building, Street name"
                            label="Unit/House no, Building, Street name"
                            v-model="form.specification"
                            ref="specification"
                        ></form-input>
                    </div>
                    <div class="col-lg-11">
                        <form-input
                            label="Barangay"
                            placeholder="Barangay"
                            v-model="form.barangay"
                            ref="barangay"
                        >
                        </form-input>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <form-input
                            placeholder="City/Municipality"
                            label="City/Municipality"
                            v-model="form.city"
                            ref="city"
                        ></form-input>
                    </div>
                    <div class="col-lg-5 col-sm-12">
                        <form-input
                            placeholder="Province"
                            label="Province"
                            v-model="form.province"
                            ref="province"
                        ></form-input>
                    </div>
                    <div class="col-lg-6">
                        <form-input
                            placeholder="Zipcode"
                            label="Zipcode"
                            v-model="form.zipcode"
                            ref="zipcode"
                        ></form-input>
                    </div>
                    <div class="col-lg-11">
                        <button v-if="!hasSelectedLocation" type="submit" disabled class="disabled btn btn-warning long float-right">
                            <i class="fa fa-save mr-1"></i> Save
                        </button>
                        <button v-else-if="!isRequesting" type="submit" class="btn btn-warning long float-right">
                            <i class="fa fa-save mr-1"></i> Save
                        </button>
                        <button v-else disabled class="disabled btn btn-warning long float-right">
                            <i class="fa fa-spinner fa-spin mr-2"></i> Please wait
                        </button>
                    </div>
                    <div v-if="!hasSelectedLocation" class="col-lg-11 text-right mt-2">
                        <i class="fa fa-info-circle mr-2"></i> <span class="text-muted">Please select the location in the map</span>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<script>
import mixins from '@utils/mixins';
import Form from '@models/components/Form';
import { route, post, patch } from "@utils/network";

export default {
    name: 'BookingAddressCreateForm',

    computed: {
        isLoggedIn() {
            return this.$store.getters.userToken != null;
        },
        hasSelectedLocation() {
            return this.form.latitude != null && this.form.longitude != null;
        }
    },

    data: () => ({
        isRequesting: false,
        showModal: false,
        clearModal: true,
        initialMapPosition: {
            lat: 14.8527252,
            lng: 120.8160598,
        },
        form: new Form({
            name: "",
            specification: "",
            barangay: "",
            city: "",
            province: "",
            zipcode: "",
            latitude: null,
            longitude: null,
            country: "Philippines",
            place_id: null,
        }),
    }),

    methods: {
        syncMapData(payload) {
            this.form.barangay = payload[0].address.barangay;
            this.form.city = payload[0].address.city;
            this.form.country = payload[0].address.country;
            this.form.latitude = payload[0].position.lat;
            this.form.longitude = payload[0].position.lng;
            this.form.province = payload[0].address.province;
            this.form.zipcode = payload[0].address.zipcode;
        },

        clearFields(includeErrors = true) {
            this.form.reset();

            if (includeErrors) {
                this.$refs.specification.clearError();
                this.$refs.barangay.clearError();
                this.$refs.city.clearError();
                this.$refs.province.clearError();
                this.$refs.zipcode.clearError();
            }
        },

        show() {
            this.showModal = true;
        },

        onHide() {
            this.showModal = false;
            if (this.clearModal) {
                this.clearFields();
            }
        },

        async save() {
            this.clearModal = this.showModal = false;
            if (this.isLoggedIn && !(await this.confirm("Are you sure you want to save this address?", "")).value) {
                this.showModal = true;
                return;
            }
            this.isRequesting = this.clearModal = this.showModal = true;
            const request = this.isLoggedIn
                ? post(route("shop-search-addresses"), { data: this.form.getData() })
                : patch(route("validate-shop-search-addresses"), { data: this.form.getData() })
            
            request
                .then(response => this.saved(response))
                .catch(error => this.saveFailed(error))
                .finally(() => (this.isRequesting = false));
        },

        saved(response) {
            if (!this.isLoggedIn) {
                this.$emit("created", this.form.getData());
                this.onHide()
                return;
            }
            this.$emit("created", response.data.result.address);
            this.promptSuccess(response.data.message)
                .then(() => this.onHide());
        },

        saveFailed(error) {
            this.promptFormErrors(this.$refs, error);
        },
    },

    mixins: [ mixins ],

}
</script>